import { Mic } from 'lucide-react';

const SpeechToSpeech = () => (
    <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium mb-6">Speech-to-Speech Conversion</h3>

        <div className="space-y-6">
            {/* Input Audio */}
            <div>
                <h4 className="text-md font-medium mb-3">Input Audio</h4>
                <div className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center">
                    <div className="space-y-2">
                        <Mic size={36} className="mx-auto text-gray-400" />
                        <p className="text-sm text-gray-500">
                            Upload an audio file or record directly
                        </p>
                        <div className="flex justify-center space-x-3">
                            <button className="px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50">
                                Upload File
                            </button>
                            <button className="px-4 py-2 bg-red-500 border border-transparent rounded-md shadow-sm text-sm text-white hover:bg-red-600">
                                Record Audio
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Target Voice */}
            <div>
                <h4 className="text-md font-medium mb-3">Target Voice</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="border rounded-md p-4 flex flex-col items-center hover:border-gray-500 cursor-pointer">
                        <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-2">
                            <span className="text-gray-600">M</span>
                        </div>
                        <p className="font-medium">Michael</p>
                        <p className="text-xs text-gray-500">Male, American</p>
                    </div>
                    <div className="border rounded-md p-4 flex flex-col items-center border-gray-500 bg-gray-50">
                        <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-2">
                            <span className="text-gray-600">A</span>
                        </div>
                        <p className="font-medium">Anna</p>
                        <p className="text-xs text-gray-500">Female, British</p>
                    </div>
                    <div className="border rounded-md p-4 flex flex-col items-center hover:border-gray-500 cursor-pointer">
                        <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-2">
                            <span className="text-gray-600">+</span>
                        </div>
                        <p className="font-medium">Custom Voice</p>
                        <p className="text-xs text-gray-500">Use your voice model</p>
                    </div>
                </div>
            </div>

            {/* Processing Options */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Emotion Preservation
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500">
                        <option>High (Preserve all emotional tones)</option>
                        <option>Medium (Balance preservation and target voice)</option>
                        <option>Low (Prioritize target voice characteristics)</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Quality Level
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500">
                        <option>Standard (Fast processing)</option>
                        <option>High (Better quality, slower)</option>
                        <option>Ultra (Premium quality, longest processing)</option>
                    </select>
                </div>
            </div>

            {/* Action Button */}
            <div className="flex justify-end">
                <button className="px-6 py-2 bg-gray-900 border border-transparent rounded-md shadow-sm text-sm text-white hover:bg-gray-800">
                    Convert Audio
                </button>
            </div>
        </div>
    </div>
);

export default SpeechToSpeech;